import { passwordResetSchema } from './PasswordResetSchema';
import API from '../../../API';
import { getLaravelValidationErrors, setToken } from '../../../helpers';
import { ROOT } from '../../../constants/routes';

const formik = ({ history }) => {
  return {
    initialValues: {
      email: '',
    },
    validationSchema: passwordResetSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      API.post('/users/password-reset', values)
        .then(response => {
          setStatus({ success: true });
          setSubmitting(false);
        })
        .catch(errors => {
          console.log('Form errors', errors);
          setStatus({ errors: getLaravelValidationErrors(errors) });
          setSubmitting(false);
        });
    },
  };
};

export default formik;
